import React from "react";
import { MenuItem, OutlinedTextFieldProps } from "@mui/material";
import {
  UseFormRegister,
  RegisterOptions,
  FieldError,
} from "react-hook-form/dist/types";

import * as Styled from "./styles";

interface InputProps extends Omit<OutlinedTextFieldProps, "error" | "variant"> {
  error: FieldError | undefined;
  name: string;
  register?: UseFormRegister<any>;
  registerOptions?: RegisterOptions<any, string>;
  selectOptions?: {
    name: string;
    value: string;
  }[];
}

const Input = ({
  label,
  error,
  name,
  register,
  registerOptions,
  selectOptions,
  value,
  onChange,
  onBlur,
  ...rest
}: InputProps) => {
  const registerResult = register ? register(name, registerOptions) : undefined;
  const { ref, ...inputProps } = registerResult || {
    ref: undefined,
  };

  const isSelect = rest.select !== undefined ? rest.select : false;

  const renderSelectOptions = () => {
    if (!isSelect) {
      return null;
    }

    if (selectOptions && selectOptions.length > 0) {
      return selectOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ));
    }

    return (
      <MenuItem value="" disabled>
        Nenhuma opção disponível
      </MenuItem>
    );
  };

  const getFinalValue = () => {
    if (value !== undefined) {
      return value;
    }
    if (registerResult && "value" in inputProps) {
      return (inputProps as any).value;
    }
    return undefined;
  };

  const getFinalOnChange = () => {
    if (onChange) {
      return onChange;
    }
    if (registerResult && "onChange" in inputProps) {
      return (inputProps as any).onChange;
    }
    return undefined;
  };

  const getFinalOnBlur = () => {
    if (onBlur) {
      return onBlur;
    }
    if (registerResult && "onBlur" in inputProps) {
      return (inputProps as any).onBlur;
    }
    return undefined;
  };

  const finalValue = getFinalValue();
  const finalOnChange = getFinalOnChange();
  const finalOnBlur = getFinalOnBlur();

  return (
    <Styled.Input
      margin="none"
      variant="outlined"
      label={label}
      error={!!error}
      helperText={error?.message}
      inputRef={ref}
      size="small"
      select={isSelect}
      name={name}
      value={finalValue}
      onChange={finalOnChange}
      onBlur={finalOnBlur}
      {...(register ? inputProps : {})}
      {...rest}
    >
      {renderSelectOptions()}
    </Styled.Input>
  );
};

export default Input;
